import * as React from 'react';
import { Util } from '@grandvisionhq/common';
import { useLazyQuery } from '@grandvisionhq/graphql';
import { alertLabels } from '../configuration/alert-labels/index.js';
import { useErrorMessageContext } from '../context/ErrorMessageContext/context.js';
import { GET_RETURN } from '../operations/queries/get-return.js';

const useLogin = ({ onCompleted , onError  } = {})=>{
    const [{ addError , clearErrors  }] = useErrorMessageContext();
    const handleOnCompleted = React.useCallback((result)=>{
        var ref;
        if ((ref = result.getReturn) === null || ref === void 0 ? void 0 : ref.failures) {
            var ref1;
            const labelMap = Util.mapFailuresToAlertLabels((ref1 = result.getReturn) === null || ref1 === void 0 ? void 0 : ref1.failures, alertLabels, 'returns.errors.returnGeneralFailure.title');
            clearErrors();
            labelMap.forEach((label)=>addError(label)
            );
        }
        onCompleted === null || onCompleted === void 0 ? void 0 : onCompleted(result);
    }, [
        addError,
        clearErrors,
        onCompleted
    ]);
    const [query, { called , data , error: error1 , loading  }] = useLazyQuery(GET_RETURN, {
        onCompleted: handleOnCompleted,
        onError (error) {
            console.error(error);
            onError === null || onError === void 0 ? void 0 : onError();
        },
        fetchPolicy: 'no-cache'
    });
    const trigger = React.useCallback((input)=>{
        query({
            variables: {
                input
            }
        });
    }, [
        query
    ]);
    return React.useMemo(()=>[
            trigger,
            {
                called,
                data,
                error: error1,
                loading
            }, 
        ]
    , [
        trigger,
        called,
        data,
        error1,
        loading
    ]);
};

export { useLogin };
//# sourceMappingURL=use-login.js.map
